import { createSlice } from '@reduxjs/toolkit'
import UserDataModel, { CustomerLoyaltyModel, UserDataPreferencesModel, UserDataUserModel } from './UserDataModel'

const initialState: UserDataModel = {
    token: '',
    user: new UserDataUserModel(),
    preferences: new UserDataPreferencesModel(),
    invoices: [],
    orders: [],
    isActive: false,
    loyalty: new CustomerLoyaltyModel()
}

export const counterSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        reducerUserLoad: (state, action) =>
        {
            if(action.payload.token)
                state.token = action.payload.token
            if(action.payload.user)
                state.user = action.payload.user
            if(action.payload.preferences)
                state.preferences = action.payload.preferences
            if(action.payload.invoices)
                state.invoices = action.payload.invoices
            if(action.payload.orders)
                state.orders = action.payload.orders
            if(action.payload.isActive !== undefined)
                state.isActive = action.payload.isActive
            if(action.payload.loyalty)
                state.loyalty = action.payload.loyalty
        },
        reducerUserOrderRefresh: (state, action) =>
        {
            state.orders = action.payload.orders
            if(action.payload.ritmitosInOrders)
                state.loyalty.ritmitosInOrders = action.payload.ritmitosInOrders
        },
        reducerUserLogout: (state) =>
        {
            state.token = ''
            state.user = new UserDataUserModel()
            state.preferences = new UserDataPreferencesModel()
            state.invoices = []
            state.orders = []
            state.isActive = false
            state.loyalty = new CustomerLoyaltyModel()
        }
    },
})

export const { reducerUserLoad, reducerUserOrderRefresh, reducerUserLogout } = counterSlice.actions
export default counterSlice.reducer
